(() => {
  // app/scripts/common/component/SearchCounter.js
  !window.customElements.get("search-counter") && window.customElements.define("search-counter", class extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector("form");
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData);
      searchParams.set("section_id", this.dataset.sectionId);
      const url = form.action + "?" + searchParams.toString();
      fetch(url).then((e) => e.text()).then((e) => {
        const count = e.split("<!-- ||| -->")[1];
        this.querySelector(".jsCounter").textContent = count;
      });
    }
  });
})();
